import React from "react";
import { FaUserCircle } from "react-icons/fa";

// One team: big circular avatar with a dark name pill overlapping its bottom —
// matching the app's TeamCard.
const TeamItem = ({ team }) => (
  <div className="w-[24%] relative">
    <div className="p-1">
      <div className="w-full aspect-square rounded-full overflow-hidden border-2 border-white/15 bg-white/[0.06]">
        {team.image?.image ? (
          <img
            src={team.image.image}
            alt=""
            className="w-full h-full object-cover"
          />
        ) : (
          <FaUserCircle className="w-full h-full text-white/30" />
        )}
      </div>
    </div>
    <div className="absolute -bottom-2 inset-x-0 bg-header border border-white/15 rounded-full py-1 px-1">
      <span className="block text-white text-[11px] font-extrabold text-center line-clamp-1">
        {team.name}
      </span>
    </div>
  </div>
);

// One mode thumbnail, matching the app's ModeCard: 3:4 tile, image fills the top
// (ratio preserved), dark name bar below that grows to fit, gold border for
// community modes.
const ModeTile = ({ mode, isCustom }) => (
  <div
    className={`flex flex-col rounded-xl overflow-hidden aspect-[3/4] border-2 bg-header ${
      isCustom ? "border-primary" : "border-white/15"
    }`}
  >
    <div className="flex-1 min-h-0 w-full">
      {mode.image ? (
        <img src={mode.image} alt="" className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full bg-white/[0.06]" />
      )}
    </div>
    <div className="shrink-0 px-1 py-1.5 border-t border-white/10 flex items-center justify-center">
      <span className="text-white text-[10px] font-extrabold text-center leading-tight line-clamp-2">
        {mode.name}
      </span>
    </div>
  </div>
);

// A created-game card, matching the app's GameCard: name (with divider) + team
// avatars + a grid of the game's mode tiles. Tap → game menu. RTL throughout.
const GameCard = ({ game, onClick }) => {
  const modes = game.modes || [];
  const customModes = game.customModes || [];
  return (
    <button
      type="button"
      dir="rtl"
      onClick={onClick}
      className="group flex flex-col text-right w-full h-full rounded-2xl p-5 bg-white/[0.05] border border-white/10 backdrop-blur-sm hover:bg-white/[0.08] hover:border-primary/40 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-header"
    >
      <div className="border-b border-white/10 pb-3">
        <h3 className="text-white font-extrabold text-lg line-clamp-1 group-hover:text-primary transition-colors">
          {game.name}
        </h3>
      </div>

      <div className="flex flex-row gap-2 pt-4 pb-6">
        {(game.teams || []).map((t, i) => (
          <TeamItem key={i} team={t} />
        ))}
      </div>

      <div className="grid grid-cols-3 gap-2">
        {modes.map((m) => (
          <ModeTile key={m._id} mode={m} />
        ))}
        {customModes.map((m) => (
          <ModeTile key={m._id} mode={m} isCustom />
        ))}
      </div>
    </button>
  );
};

export default GameCard;
